import CountryPageRenderer from '../components/CountryPageRenderer';
import brazilData from '../data/country-pages/brazil';

export default function BrazilCountryPage() {
  return <CountryPageRenderer data={brazilData} />;
}
